
namespace RioERP.Common {
    export class SMSColumns {
        static columnsKey = 'Common.SMS';
    }
}